<template>
  <div class="loader_popover">
    <div class="popover_content p-3" >

        <div class="loader loader3">
            <svg width="80px" height="20px" viewBox="0 0 38 8">
            <circle fill="#FFEDEE" cx="4" cy="4" r="4"/>
            <circle fill="#FFEDEE" cx="19" cy="4" r="4"/>
            <circle fill="#FFEDEE" cx="34" cy="4" r="4"/>
            <rect x="0" y="0" width="8" height="8" rx="4" ry="4" fill="#FB6672"/>
            </svg>
        </div>

    </div>
  </div>
</template>

<style scoped>
    .loader_popover{
        position: fixed;
        z-index: 2000;
        top:0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(255,255,255,0.8);
    }

    .popover_content{
        position: fixed;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

    .loader3 svg rect {
        opacity: 0;
        animation: loader3path 2s ease-in-out infinite;
    }

</style>

<script>
export default {
    name: 'loader_popover',
    data(){
        return {
        }
    },
    props: {
        action : String,
        value : Number
    },
    methods:{

        async updateStatus(status){
            await this.$store.commit('service_status_update',[this.$session.get('book_id'),this.$session.get('multi_book_id'),status,this.$store.state.user_id,this.Constants.BOOKED_THROUGH_ADMIN]);
            this.$emit('changePopStatus');
        },

        cancelStatus(){
            this.$emit('cancelPopStatus');
        }

    }
}
</script>